import Fields from "./Fields";
import IconPicker from "./IconPicker";
import KindPicker from "./KindPicker";
import SmartAttributes from "./SmartAttributes";

export default {
  Fields,
  IconPicker,
  KindPicker,
  SmartAttributes
};
